import React, { Suspense, useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, is_private = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && is_private) {
		return (
			<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
		);
	}

	if (isAuth && !is_private) {
		return (
			<Redirect to={{ pathname: "/", state: { from: rest.location } }} />
		);
	}

	return (
		<RouterRoute
			{...rest}
			render={(props) => (
				<Suspense fallback={<BackdropLoading />}>
					<Component {...props} />
				</Suspense>
			)}
		/>
	);
};

export default Route;
